import React, { useContext } from "react"
import "./Styles/list.scss"
import classNames from "classnames"

import Summary from "../Common/Place/Summary"
import Feedback from "../Common/Feedback"
import Loader from "../Common/Loader"
import { PCViewContext } from "../Common/PCViewContext"

const CrowdList = (props) => {
  const isPC = useContext(PCViewContext)
  return (
    <React.Fragment>
      <h2 className={classNames("p-top-section__header", isPC ? "pc" : "sp")}>
        最新の混雑情報
      </h2>
      <Loader show={props.showLoader} color="green" small={false} />
      {props.places.map((place) => (
        <React.Fragment key={place.id}>
          <div className="p-top-section__row">
            <Summary place={place} {...props} />
          </div>
          <hr className="common-hr" />
        </React.Fragment>
      ))}
      {props.places.length > 0 && (
        <div style={{ margin: "1rem 0 0" }}>
          <Feedback />
        </div>
      )}
    </React.Fragment>
  )
}

export default CrowdList
